import Image from "next/image";
import { FC, useState } from "react";
import { ProductDetailsResponse } from "@/types/product";

const ProductCardImage: FC<{
  product: ProductDetailsResponse;
}> = ({ product }) => {
  const [imgSrc, setImgSrc] = useState(
    product.images?.[0] || "/img/No_Image.jpg",
  );

  const handleImageError = () => {
    setImgSrc("/img/No_Image.jpg");
  };

  return (
    <Image
      src={imgSrc}
      alt="related-image"
      fill
      className="object-contain cursor-pointer block rounded-md shadow-sm hover:scale-105 overflow-hidden transition-transform duration-300 ease-in-out"
      onError={handleImageError}
    />
  );
};

export default ProductCardImage;
